const hostname = window.location.hostname

const DEFAULT_BFF_URL = 'ubilink.ubisafe.io/bff/v1/mobile/customer'
const DEV_BFF_URL = 'ubilink.dev.ubisafe.io/bff/v1/mobile/customer'
const isDevEnvironment =
  hostname.includes('.dev.ubisafe.io') || hostname.includes('localhost')

const handleBffUrl = () => {
  return `https://app.${isDevEnvironment ? DEV_BFF_URL : DEFAULT_BFF_URL}`
}

export const BFF_URL = handleBffUrl()
